import React from 'react';
import { Badge, Button } from 'shards-react';
import { useTranslation } from 'react-i18next';

interface EditConditionCustomizeProps {
  editable: boolean;
  saved: boolean;
  onClick: () => void;
}

const EditConditionCustomize = ({ editable, saved, onClick }: EditConditionCustomizeProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <Button className="mr-2" size="sm" disabled={!editable} onClick={onClick}>
        {t('condition.addDetail')}
      </Button>
      {!saved && (
        <div className="d-flex align-items-center">
          <Badge outline theme="danger">
            {t('condition.nonsave')}
          </Badge>
        </div>
      )}
    </>
  );
};

export default EditConditionCustomize;
